import script from "./GenerateVxml.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateVxml.vue?vue&type=script&setup=true&lang=js"

import "./GenerateVxml.vue?vue&type=style&index=0&id=c68f4214&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c68f4214"]])

export default __exports__